import { FC } from "react";
import SimpleDataTable from "../common/simple-data-table";
import { PRACTITIONER_SUBSCRIPTIONS_WITH_NAME_COLUMNS } from "lib/constants/table-columns";

interface AllPractitionerSubscriptionsProps {
  subscriptions: PractitionerSubscriptionDetails[];
  onSubscriptionClick: (subscription: PractitionerSubscriptionDetails) => void;
}

const AllPractitionerSubscriptions: FC<AllPractitionerSubscriptionsProps> = ({
  subscriptions,
  onSubscriptionClick,
}) => {
  return (
    <SimpleDataTable
      data={subscriptions}
      columns={PRACTITIONER_SUBSCRIPTIONS_WITH_NAME_COLUMNS}
      onRowClick={onSubscriptionClick}
    />
  );
};

export default AllPractitionerSubscriptions;
